import { z } from 'zod';
import { platformSchema, supportStateSchema } from './primitives.js';
/**
 * Cursor-Pagination ist Pflicht. Der komplette Katalog wird nie an den
 * Client geschickt – es gibt bewusst kein "alle laden".
 */
export const cursorPageRequestSchema = z.object({
    cursor: z.string().nullable().default(null),
    limit: z.number().int().min(1).max(50).default(20),
});
export const gameSearchRequestSchema = cursorPageRequestSchema.extend({
    query: z.string().default(''),
    platform: platformSchema.nullable().default(null),
    supportState: supportStateSchema.nullable().default(null),
    groupByFranchise: z.boolean().default(false),
});
//# sourceMappingURL=query.js.map